/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
"use strict";

{
	const lang = {
		"it": {
			"addToCart": "Aggiungi a carrello",
			"addedToCart": "Aggiunto a carrello",
			"remove": "Rimuovi"
		},
		"en": {
			"addToCart": "Add to cart",
			"addedToCart": "Added to cart",
			"remove": "Remove"
		},
		"ja": {
			"addToCart": "japanes add",
			"addedToCart": "japanese added",
			"remove": "japanese remove"
		}
	}
	const productCardMarkup = `<div class="swym-wishlist-grid">
	{{#products}} 
		<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
			<div class="wishlist-item">
				<div class="wishlist-item-image">
					<img alt="" class="swym-wishlist-image" src="{{iu}}">
				</div>
				<div class="wishlist-item-content">
					<div class="wishlist-item-details">
						<div class="wishlist-item-details-title">
							<h3 class="h3-mobile">
								{{dt}}
							</h3>
							<p class="wishlist-item-details-variant">
								{{variantinfo}}
							</p>
							<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button body-3-regular">
								Remove
							</button>
						</div>
						<div class="wishlist-items-details-price">
							<p class="h5">{{cu}}{{pr}}</p>
						</div>
					</div>
					<div class="wishlist-item-add-to-cart only-desktop">
						<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button btn" {{#isInCart}}disabled{{/isInCart}}>
						<svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.6667V4.00008H2.66667C2.66667 3.07786 2.99167 2.29175 3.64167 1.64175C4.29167 0.991748 5.07778 0.666748 6 0.666748C6.92222 0.666748 7.70833 0.991748 8.35833 1.64175C9.00833 2.29175 9.33333 3.07786 9.33333 4.00008H12V14.6667H0ZM1.33333 13.3334H10.6667V5.33342H1.33333V13.3334ZM6 9.33342C6.92222 9.33342 7.70833 9.00842 8.35833 8.35842C9.00833 7.70842 9.33333 6.9223 9.33333 6.00008H8C8 6.55564 7.80556 7.02786 7.41667 7.41675C7.02778 7.80564 6.55556 8.00008 6 8.00008C5.44444 8.00008 4.97222 7.80564 4.58333 7.41675C4.19444 7.02786 4 6.55564 4 6.00008H2.66667C2.66667 6.9223 2.99167 7.70842 3.64167 8.35842C4.29167 9.00842 5.07778 9.33342 6 9.33342ZM4 4.00008H8C8 3.44453 7.80556 2.9723 7.41667 2.58341C7.02778 2.19453 6.55556 2.00008 6 2.00008C5.44444 2.00008 4.97222 2.19453 4.58333 2.58341C4.19444 2.9723 4 3.44453 4 4.00008Z" fill="white"/></svg>
						{{#isInCart}}
							<span class="h5 color-white">
								Added to cart
							</span>
						{{/isInCart}}
						{{^isInCart}}
							<span class="h5 color-white">
								Add to cart
							</span>
						{{/isInCart}}
						</button>
						<div class="add-to-cart-error-container body-3-regular color-red" data-error-product-url="{{epi}}"></div>
					</div>
				</div>
			</div>
			<div class="wishlist-item-add-to-cart only-mobile">
				<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button btn" {{#isInCart}}disabled{{/isInCart}}>
				<svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.6667V4.00008H2.66667C2.66667 3.07786 2.99167 2.29175 3.64167 1.64175C4.29167 0.991748 5.07778 0.666748 6 0.666748C6.92222 0.666748 7.70833 0.991748 8.35833 1.64175C9.00833 2.29175 9.33333 3.07786 9.33333 4.00008H12V14.6667H0ZM1.33333 13.3334H10.6667V5.33342H1.33333V13.3334ZM6 9.33342C6.92222 9.33342 7.70833 9.00842 8.35833 8.35842C9.00833 7.70842 9.33333 6.9223 9.33333 6.00008H8C8 6.55564 7.80556 7.02786 7.41667 7.41675C7.02778 7.80564 6.55556 8.00008 6 8.00008C5.44444 8.00008 4.97222 7.80564 4.58333 7.41675C4.19444 7.02786 4 6.55564 4 6.00008H2.66667C2.66667 6.9223 2.99167 7.70842 3.64167 8.35842C4.29167 9.00842 5.07778 9.33342 6 9.33342ZM4 4.00008H8C8 3.44453 7.80556 2.9723 7.41667 2.58341C7.02778 2.19453 6.55556 2.00008 6 2.00008C5.44444 2.00008 4.97222 2.19453 4.58333 2.58341C4.19444 2.9723 4 3.44453 4 4.00008Z" fill="white"/></svg>
				{{#isInCart}}
					<span class="h5 color-white">
						Added to cart
					</span>
				{{/isInCart}}
				{{^isInCart}}
					<span class="h5 color-white">
						Add to cart
					</span>
				{{/isInCart}}
				</button>
				<div class="add-to-cart-error-container body-3-regular color-red" data-error-product-url="{{epi}}"></div>
			</div>
		</a>
	{{/products}}
	</div>`;

	function getVariantInfo(variants) {
		try {
			let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
				variantinfo;
			if (variantKeys.length > 0) {
				variantinfo = variantKeys[0];
				if (variantinfo == "Default Title") {
					variantinfo = "";
				}
			} else {
				variantinfo = "";
			}
			return variantinfo;
		} catch (err) {
			return variants;
		}
	}

	function onAddToCartClick(e) {
		e.preventDefault();
		var productId = e.currentTarget.getAttribute("data-product-id");
		var variantId = e.currentTarget.getAttribute("data-variant-id");
		var du = e.target.getAttribute("data-product-url");
		e.target.innerHTML = "Adding..";
		const id = variantId ? variantId : productId;
		let formData = {
			'items': [{
				'id': id,
				'quantity': 1
			}]
		}
		fetch(theme.routes.cartAdd, {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
			.then(response => {
				return response.json()
			})
			.then((result) => {
				if (result.status === 422 || result.status === 'bad_request') {
					const errorContainer = window.document.querySelectorAll(`.add-to-cart-error-container[data-error-product-url="${variantId}"]`);
					if (errorContainer.length < 1) return;

					errorContainer.forEach(errorMessageContainer => {
						errorMessageContainer.innerHTML = result.description;
						const container = errorMessageContainer.closest('.wishlist-item-add-to-cart')
						container.querySelector('button').setAttribute('disabled', "true");
						container.querySelector('button span').innerHTML = 'Add to Cart';
					})
				}
				else {
					e.target.innerHTML = "Added to Cart";
					e.target.setAttribute("data-state-cart", "swym-added");

					var product = result;
					document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
						detail: {
							product: product,
							addToCartBtn: e.target
						}
					}));
				}
			})
			.catch((error) => {
				console.log("Error:", error)
			})
	}

	function onRemoveBtnClick(e) {
		e.preventDefault();
		var epi = +e.currentTarget.getAttribute("data-variant-id");
		var empi = +e.currentTarget.getAttribute("data-product-id");
		window._swat.fetch(function (products) {
			products.forEach(function (product) {
				if (epi && empi && product.epi == epi && product.empi == empi) {
					window._swat.removeFromWishList(product, () => swymRenderWishlist(window._swat))
				}
			});
		})
	}

	function swymRenderWishlist(swat) {
		// Get wishlist items
		swat.fetch(function (products) {
			// Init wishlistBubble
			const wishlistBubble = window.document.querySelector('.wishlist__bubble');

			if (wishlistBubble) {
				if (products.length > 0) {
					wishlistBubble.classList.add('wishlist__bubble--visible');
					wishlistBubble.querySelector('.wishlist__bubble-num').innerHTML = products.length;
				}
				else wishlistBubble.querySelector('.wishlist__bubble-num').innerHTML = 0;
			}

			const wishlistContentsContainer = document.getElementById("wishlist-items-container");
			const formattedWishlistedProducts = products.map(function (p) {
				p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
				p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
				p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
				return p;
			});
			const productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
				products: formattedWishlistedProducts
			});
			if (wishlistContentsContainer) {
				// Hide loading message
				window.document.getElementById('LoadingWishlistMessage').classList.add('hide');
				// Show empty message for empty wishlist
				if (products.length < 1) window.document.getElementById('EmptyWishlistMessage').classList.remove('hide');
				wishlistContentsContainer.innerHTML = productCardsMarkup;
				attachClickListeners();
			}
			// else{
			// 	console.log("Container not found, Wishlist Page element not found");
			// }
		});
	}

	function attachClickListeners() {
		var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
		var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
		//   Add to cart Btns
		for (var i = 0; i < addToCartButtons.length; i++) {
			addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
		}
		//   Remove Buttons
		for (var k = 0; k < removeBtns.length; k++) {
			removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
		}
	}

	function handleWishlistBubble(action) {
		const wishlistBubble = window.document.querySelector('.wishlist__bubble');
		if (!wishlistBubble) return;

		if ((!wishlistBubble.classList.contains('wishlist__bubble--visible')) && action)
			wishlistBubble.classList.add('wishlist__bubble--visible');

		let wishlistItemCount = parseInt(wishlistBubble.querySelector('.wishlist__bubble-num')?.innerHTML, 10);

		if (action) wishlistItemCount++;
		else {
			wishlistItemCount--;
			if (wishlistItemCount === 0) wishlistBubble.classList.remove('wishlist__bubble--visible');
		}

		wishlistBubble.querySelector('.wishlist__bubble-num').innerHTML = wishlistItemCount;
	}

	function onAccountLoing(swat) {
		let event = swat.JSEvents.customerInfoRefreshed;

		let listener = function (e) {
			swat.authCheck(function (shopperContext) {
				if (!shopperContext.authn) return;
				window.customWishlistG.customer.email = shopperContext.email;
				if (shopperContext.regn.userinfo.fname) window.customWishlistG.customer.firstName = shopperContext.regn.userinfo.fname
				if (shopperContext.regn.userinfo.lname) window.customWishlistG.customer.lastName = shopperContext.regn.userinfo.lname
			});
		}
		swat.evtLayer.addEventListener(event, listener);
	}

	function onSwymLoadCallback(swat) {
		if (swat) {
			swat.evtLayer.addEventListener('sw:addedtowishlist', () => {
				handleWishlistBubble(true)
			});
			swat.evtLayer.addEventListener('sw:removedfromwishlist', () => {
				handleWishlistBubble(false)
			});

			document.querySelectorAll('.swym-button').forEach(
				(btn) => {
					setTimeout(() => {
						btn.removeAttribute('style');
					}, 500);
				}
			)

			swymRenderWishlist(swat);
			onAccountLoing(swat);
		}
	}

	if (!window.SwymCallbacks) {
		window.SwymCallbacks = [];
	}
	window.SwymCallbacks.push(onSwymLoadCallback);
}